import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const HowItWorks = () => {
  const benefits = [
    "We are almost 50% cheaper than most similar services!",
    "We deliver 1 to 4 times per year, depending on the quantity you order.",
    "You can pay weekly, bi-weekly, or monthly with 0% interest.",
    "Our products are health Canada-certified for 24 months.",
    "All products are vacuum-sealed individually.",
    "Thawing only takes 15 to 25 minutes under cold water.",
    "Local, no added GMOs, preservatives, or additives.",
    "Everything comes from local Canadian producers."
  ];

  return (
    <div className="bg-white py-8 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4">How does it work?</h2>
          <p className="text-base sm:text-lg text-gray-600">
            Book a free appointment with a NeighborFood specialist via Zoom or in person
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
          <div className="space-y-4 sm:space-y-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-custom-green flex-shrink-0 mt-0.5" />
                <p className="text-sm sm:text-base text-gray-700">{benefit}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 gap-2 sm:gap-4">
            <img 
              src="https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=400&q=80" 
              alt="Premium steak" 
              className="w-full h-32 sm:h-40 object-cover rounded-lg shadow-md"
            />
            <img 
              src="https://images.unsplash.com/photo-1526471160464-18556e5e7d5f?auto=format&fit=crop&w=400&q=80" 
              alt="Fresh salmon" 
              className="w-full h-32 sm:h-40 object-cover rounded-lg shadow-md"
            />
            <img 
              src="https://images.unsplash.com/photo-1602470520998-f4a52199a3d6?auto=format&fit=crop&w=400&q=80" 
              alt="Chicken preparation" 
              className="w-full h-32 sm:h-40 object-cover rounded-lg shadow-md"
            />
            <img 
              src="https://images.unsplash.com/photo-1615937722923-67f6deaf2cc9?auto=format&fit=crop&w=400&q=80" 
              alt="Vacuum sealed meat" 
              className="w-full h-32 sm:h-40 object-cover rounded-lg shadow-md"
            />
          </div>
        </div>

        <div className="mt-8 sm:mt-12 text-center">
          <Link
            to="/booking"
            className="inline-block w-full sm:w-auto bg-custom-red text-white px-6 sm:px-8 py-3 rounded-md hover:bg-custom-red/90 transition-colors"
          >
            Schedule Consultation
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;